import { phone } from '@polvo-labs/form-utils'
import { Fetch, useAuth } from '@polvo-labs/react-auth'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../../components/Button'
import Loader from '../../../../components/Loader'
import Pagination from '../../../../components/Pagination'
import Table from '../../../../components/Table'
import routes from '../../../../config/routes'
import UserType from '../../../../models/User'
import isAdmin from '../../../../utils/is-admin'
import CardColors from '../../CardColors'
import PageContent from '../../PageContent'
import PageHeader from '../../PageHeader'
import Filter from './Filter'
import { Container } from './styles'
import DeleteUser from './deleteUser'
import RecoveryUser from './recoveryUser'

interface Props {

}

const UserListScreen: React.FC<Props> = () => {
  const cacheParams = JSON.parse(localStorage.getItem('user_list_params') || '{}')
  const defaultApiUrl = `${process.env.REACT_APP_API_URL}/users`
  const [apiUrl, setApiUrl] = useState(localStorage.getItem('user_list_api_url') || defaultApiUrl)
  const [params, setParams] = useState<any>(cacheParams || {})
  const [users, setUsers] = useState<UserType[]>([])
  const history = useHistory()
  const { user } = useAuth()

  useEffect(() => {
    localStorage.setItem('user_list_api_url', apiUrl)
    localStorage.setItem('user_list_params', JSON.stringify(params))
  }, [params, apiUrl])

  return (
    <div>
      <PageHeader
        title="Usuários"
        subtitle="Lista de usuários"
        side={isAdmin(user) ? (
          <Button
            label="Criar usuário"
            backgroundColor="darkBlue"
            fontColor="white"
            borderColor="lightGray"
            small
            onClick={() => history.push(routes.admin.user.create.path)}
          />
        ) : undefined}
      />
      <PageContent>
        <Fetch
          url={`${process.env.REACT_APP_API_URL}/dashboard`}
        >
          {({ data }) => data && data.data && (
            <CardColors
              data={[
                {
                  color: '#3c5499',
                  label: 'Total de Usuários',
                  content: data.data.usuarios.cadastros.toString(),
                },
                {
                  color: '#01caf1',
                  label: 'Usuários com Imóveis',
                  content: data.data.usuarios.comImoveis.toString(),
                },
                {
                  color: '#ff4f70',
                  label: 'Propostas Feitas',
                  content: data.data.usuarios.comPropostas.toString(),
                },
                {
                  color: '#22ca80',
                  label: 'Propostas Aceitas',
                  content: data.data.usuarios.comPropostasAceitas.toString(),
                },
              ]}
            />
          )}
        </Fetch>
        <Filter
          initialParams={params}
          onChange={(newParams) => {
            setApiUrl(defaultApiUrl)
            setParams(newParams)
          }}
        />
        <Fetch
          url={apiUrl}
          params={params}
          loader={() => (
            <Loader
              darkMode
            />
          )}
        >
          {({ data }) => {
            if(data && data.data)
              setUsers(data.data)
            return data && data.data ? (
              <Container>
                {users.length ? (
                  <>
                    <Table
                      header={[
                        'ID',
                        'Nome',
                        'Cidade',
                        'Telefone',
                        'CPF',
                        'Ano de Nascimento',
                        'Imóveis cadastrados',
                        '',
                      ]}
                      items={users.map((user: UserType) => [
                        user.id,
                        user.name,
                        user.city,
                        phone.format(user.phone),
                        user.cpf,
                        user.birth_year,
                        user.realties_count,
                      ])}
                      actions={users.map((user: UserType, i: number) =>
                      {
                        if(!params.deleted)
                        {
                          return <DeleteUser
                            key={'recovery'+user.id}
                            user={user}
                            afterDelete={()=>{
                              setUsers(users.splice(i,1))
                            }}
                          />}
                        else {
                          return <RecoveryUser
                            key={'delete'+user.id}
                            user={user}
                            afterRecover={()=>{
                              setUsers(users.splice(i,1))
                            }}
                          />
                        }
                      })}
                      onClick={item => {
                        if(!params.deleted){
                          history.push(
                            // eslint-disable-next-line max-len
                            routes.admin.user.show.pathFor(parseInt(item[0], 10)),
                          )}
                      }}
                    />

                    <Pagination
                      meta={data.meta}
                      links={data.links}
                      onChange={setApiUrl}
                    />
                  </>
                ) : (
                  <span>Nenhum resultado encontrado</span>
                )}
              </Container>
            ) : (
              <span>
                Error
              </span>
            )
          }}
        </Fetch>
      </PageContent>
    </div>
  )
}

export default UserListScreen
